export var types = {
    START_GC: 'START_GC',
    INSPECT_SUBS: 'INSPECT_SUBS',
    INSPECT_UNSUBS: 'INSPECT_UNSUBS',
};
export var startGC = function () {
    return {
        type: types.START_GC,
    };
};
export var inspectSubs = function () {
    return {
        type: types.INSPECT_SUBS,
    };
};
export var inspectUnsubs = function () {
    return {
        type: types.INSPECT_UNSUBS,
    };
};
//# sourceMappingURL=gc.js.map